<template>
  <div
    v-if  = "showPagination"
    class = "ln-pg__box"
  >
    <div class="ln-pg__content">
      <div class="ln-pg__prev" @click="toRelPage(-1)" v-if="showPrevIcon">上一頁</div>
      <div
        v-for  = "(item, idx) in pageItems"
        :class = "item.class"
        :key   = "`item-${idx}`"
        @click = "setCurrentPage(item)"
      >
        {{ item.label }}
      </div>
      <div class="ln-pg__next" @click="toRelPage(1)" v-if="showNextIcon">下一頁</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Pagination',
  data () {
    return {
      currentPage: 0,
      pageCount: 0,
      itemCount: 0,
      pageItems: [],
      borderShowCount: 5
    }
  },
  props: {
    pgInfo: Object
  },
  watch: {
    async pgInfo () {
      this.currentPage = this.pgInfo.current_page
      this.pageCount = this.pgInfo.total_page
      this.itemCount = this.pgInfo.total_count

      if (this.isLegal) {
        if (this.itemCount === 0 || this.currentPage > this.pageCount) {
          this.$emit('change', this.pageCount)
          return
        }
      }

      this.reRenderPagination()
    }
  },
  methods: {
    toRelPage (rel) {
      this.currentPage = this.currentPage + rel
      this.reRenderPagination()

      this.$emit('change', this.currentPage)
    },
    setCurrentPage (item) {
      if (item.label === this.currentPage) {
        return
      }

      if (item.type === 'dots') {
        return
      }

      this.currentPage = item.label
      this.reRenderPagination()

      this.$emit('change', this.currentPage)
    },
    reRenderPagination () {
      if (this.pageCount === 1) {
        this.currentPage = 1
        this.pageItems = [this.createNumItem(1)]
        return
      }

      if (this.pageCount < this.borderShowCount) {
        this.pageItems = this.createNumItemByRange(1, this.pageCount)
        return
      }

      if (this.currentPage < this.borderShowCount) {
        this.pageItems = this.createNumItemByRange(1, this.borderShowCount - 1).concat([this.createDotsItem()]).concat([this.createNumItem(this.pageCount)])
        return
      }

      if (this.currentPage > this.pageCount - this.borderShowCount + 1) {
        this.pageItems = [this.createNumItem(1)].concat([this.createDotsItem()]).concat(this.createNumItemByRange(this.pageCount - this.borderShowCount + 2, this.pageCount))
        return
      }

      this.pageItems = [this.createNumItem(1)].concat([this.createDotsItem()]).concat(this.createNumItemByRange(this.currentPage - 1, this.currentPage + 1)).concat([this.createDotsItem()]).concat([this.createNumItem(this.pageCount)])
    },
    createNumItemByRange (start, end) {
      const tmpItems = []
      for (let i = start; i <= end; i++) {
        tmpItems.push(this.createNumItem(i))
      }

      return tmpItems
    },
    createNumItem (num) {
      const htmlClass = ['ln-pg__num']
      if (num === this.currentPage) {
        htmlClass.push('ln-pg__num--active')
      }

      return { label: num, class: htmlClass, type: 'num' }
    },
    createDotsItem () {
      return { label: '...', class: ['ln-pg__dots'], type: 'dots' }
    }
  },
  computed: {
    isLegal () {
      return this.currentPage !== 0 && this.pageCount !== 0
    },
    showPagination () {
      return this.isLegal
    },
    showPrevIcon () {
      return this.pageItems.length > 1 && this.currentPage > 1
    },
    showNextIcon () {
      return this.pageItems.length > 1 && this.currentPage < this.pageCount
    }
  }
}
</script>
